import Box from '@material-ui/core/Box';
import { findIndex, isFunction, omit } from 'lodash';
import React, { useEffect, useState } from 'react';
import type { TimeProps } from './index.view';
import { RowDataProps, RowHour, RowTitle } from './index.view';

const initHours = [
  6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 1, 2, 3, 4, 5,
];

export type DayPlannerProps = {
  hours?: Array<number>;
  data: Array<RowDataProps>;
  onChange?: (data: Array<RowDataProps>) => void;
  disabled?: boolean;
  unfocus?: Array<string>;
  isPrint?: boolean;
};

const defaultValue = [
  {
    key: 'rechts',
    title: 'Rechts',
    times: [],
  },
  {
    key: 'links',
    title: 'Links',
    times: [],
  },
  {
    key: 'move',
    title: 'Rücken',
    times: [],
  },
  {
    key: 'mobilization',
    title: 'Mobilisation',
    times: [],
  },
  {
    key: 'wc_gang',
    title: 'WC-Gang',
    times: [],
  },
  {
    key: 'incontinence_care',
    title: 'Inkontinenz-versorgung',
    times: [],
  },
];

const DayPlanner: React.VFC<DayPlannerProps> = ({
  hours = initHours,
  data = defaultValue,
  onChange,
  disabled,
  unfocus = [],
  isPrint,
}) => {
  const [activities, setActivities] = useState([...data]);

  useEffect(() => {
    setActivities([...data]);
  }, [data]);

  const handleToggle = (values: {
    activityIndex: number;
    key: string;
    hour: number;
    type: 'first' | 'last';
  }) => {
    if (disabled) return;
    if (!values) return;

    const newActivities = [...activities];
    const newActivity = { ...activities[values.activityIndex] };
    const newTimes = [...newActivity.times];

    if (findIndex(newTimes, ['hour', values.hour]) === -1) {
      newTimes.push({
        hour: values.hour,
        first: values.type === 'first',
        last: values.type === 'last',
      });
    } else {
      const i = findIndex(newTimes, ['hour', values.hour]);
      const time = newTimes[i];
      newTimes[i] = {
        ...time,
        [values.type]: !time[values.type],
      };
    }

    newActivity.times = newTimes.map((time) => omit(time, ['__typename']) as TimeProps);
    newActivities[values.activityIndex] = newActivity;

    isFunction(onChange) && onChange(newActivities);
    setActivities(newActivities);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        columnGap: 2,
        gridTemplateColumns: 'auto 1fr',
      }}
    >
      <RowTitle unfocus={unfocus} rows={activities} isPrint={isPrint} />
      <RowHour
        hours={hours}
        rows={activities}
        handleClick={handleToggle}
        disabled={disabled}
        isPrint={isPrint}
      />
    </Box>
  );
};

export default DayPlanner;
